<!-- eslint-disable vue/valid-v-for -->
<template>
  <div class="routeanalysis-bd" v-if="funcView.routeanalysis_count_list || funcView.routeanalysis_area_list || funcView.routeanalysis_time_list">
    <div class="tab-box">
      <el-form :inline="true" @submit.native.prevent class="form-screen">
        <el-tabs v-model="statusState">
          <el-tab-pane :label="$t('routeanalysis_qing_jie_ci_shu')" name="count" v-if="funcView.routeanalysis_count_list"></el-tab-pane>
          <el-tab-pane :label="`${$t('routeanalysis_qing_jie_mian_ji')} (${$formatLenUnit()})`" name="area" v-if="funcView.routeanalysis_area_list"></el-tab-pane>
          <el-tab-pane :label="$t('routeanalysis_qjsc')" name="time" v-if="funcView.routeanalysis_time_list"></el-tab-pane>
        </el-tabs>
      </el-form>
    </div>
    <div class="routeanalysis-list">
      <!-- 过滤 -->
      <div class="table-list">
        <div class="header">
          <div class="search-content">
            <el-form :inline="true" @submit.native.prevent>
              <el-form-item style="float: right; margin-right: 0">
                <custom-column ref="column"></custom-column>
              </el-form-item>
              <el-form-item style="float: right">
                <i class="icon icon-shaixuan icon-filter" @click="isFilter = !isFilter"></i>
              </el-form-item>
              <el-form-item style="float: right">
                <custom-date-picker
                  v-model="formSearch.timeRange"
                  :init-value="initValue"
                  type="daterange"
                  align="right"
                  unlink-panels
                  value-format="YYYY-MM-DD HH:mm:ss"
                  @init="onPageChange({ page: 1 })"
                  @change="onPageChange({ page: 1 })"
                  :start-placeholder="$t('routeanalysis_kai_shi_ri')"
                  :end-placeholder="$t('routeanalysis_jie_shu_ri')"
                ></custom-date-picker>
              </el-form-item>
              <!-- <el-form-item style="float: right" v-if="(statusState==='count'&&funcView.routeanalysis_count_list) ||(statusState==='area'&&funcView.routeanalysis_area_list) ||(statusState==='time'&&funcView.routeanalysis_time_list)  ">
                <el-button class="custom-btn" icon="icon icon-export-excel left-icon" type="info" round
                  @click="exportRecord">导出</el-button>
              </el-form-item> -->
            </el-form>
          </div>
        </div>
        <!-- 过滤 -->
        <div class="query-filter" style="margin-top: 24px; width: 100%; padding: 0">
          <div class="params-form"  v-show="isFilter">
            <el-row :gutter="23">
              <el-col :span="8" v-if="isCoJv && showSubsidiary">
                <div class="item">
                  <div class="label">{{ $t('routeanalysis_gsmc') }}</div>
                  <div class="value">
                    <!-- orgType 总部:HQ 售后公司:SC 代理公司:JV 服务公司:SC,JV 大客户:CO 租赁方:CS -->
                    <custom-select
                      url="OrganSelect"
                      :model="formSearch"
                      :params="{ childOrgType: 'CS' }"
                      v-model="formSearch.customerId"
                      :props="{ label: 'partnerName', value: 'partnerOrgId', map: { partnerName: 'orgName' } }"
                      :placeholder="$t('com_please_select')"
                      @change="onPageChange({ page: 1 })"
                      filterable
                    ></custom-select>
                  </div>
                </div>
              </el-col>
              <el-col :span="8">
                <div class="item">
                  <div class="label">{{ `${$t('routeanalysis_xmqymc')}` }}</div>
                  <div class="value">
                    <el-input v-model="formSearch.keyword" @input="onPageChange({ page: 1 })" clearable :placeholder="$t('com_please_input')"></el-input>
                  </div>
                </div>
              </el-col>
              <el-col :span="8">
                <div class="item">
                  <div class="label">{{ $t('routeanalysis_qi_dian_ma') }}</div>
                  <div class="value">
                    <el-input v-model="formSearch.hlcCode" @input="onPageChange({ page: 1 })" clearable :placeholder="$t('com_please_input')"></el-input>
                  </div>
                </div>
              </el-col>
              <el-col :span="8">
                <div class="item">
                  <div class="label">{{ $t('routeanalysis_di_tu_ming_cheng') }}</div>
                  <div class="value">
                    <el-input v-model="formSearch.mapName" @input="onPageChange({ page: 1 })" clearable :placeholder="$t('com_please_input')"></el-input>
                  </div>
                </div>
              </el-col>
              <!-- <el-col :span="8">
                <div class="item select-date">
                  <div class="label">时间</div>
                  <div class="value">
                    <custom-date-picker
                      v-model="formSearch.timeRange"
                      :init-value="initValue"
                      type="daterange"
                      align="right"
                      unlink-panels
                      value-format="YYYY-MM-DD HH:mm:ss"
                      @init="onPageChange({ page: 1 })"
                      @change="onPageChange({ page: 1 })"
                      start-placeholder="开始日"
                      end-placeholder="结束日"
                    ></custom-date-picker>
                  </div>
                </div>
              </el-col> -->
              <el-col :span="8">
              <div class="item">
                <div class="label">{{ $t('routeanalysis_suo_shu_bu_men') }}</div>
                <div class="value">
                  <custom-select
                    url="DepartmentTree"
                    v-model="formSearch.departmentId"
                    :model="formSearch"
                    :props="{ label: 'bizName', value: 'bizId',checkStrictly: true,map: { bizName: 'departmentName' } }"
                    :params="{ isCountDevice:1 }"
                    :placeholder="$t('com_please_select')"
                    width="100%"
                    ref="tag"
                    type="tree"
                    filterable
                    :dataFilter="departmentTreeFilter"
                    @treeValChange="onPageChange({ page: 1 })"
                    @treeValChangeLabel="onDepartmentLabel"
                    @getList="onDepartmentList"
                    :clearable="false"
                  ></custom-select>
                </div>
              </div>
            </el-col>
            </el-row>
          </div>
          <div class="filter-values">
            <div class="label">{{ $t('routeanalysis_shai_xuan_xiang') }}：</div>

            <div class="values">
              <el-tag
                v-if="formSearch.customerId"
                closable
                @close="
                  formSearch.customerId = '';
                  formSearch.orgName = '';
                  onPageChange({ page: 1 });
                "
              >
                {{ formSearch.orgName }}
              </el-tag>
              <el-tag
                v-if="formSearch.keyword"
                closable
                @close="
                  formSearch.keyword = '';
                  onPageChange({ page: 1 });
                "
              >
                {{ formSearch.keyword }}
              </el-tag>
              <el-tag
                v-if="formSearch.departmentId"
                closable
                @close="
                  formSearch.departmentId = '';
                  formSearch.departmentName = '';
                  onPageChange({ page: 1 });
                "
              >
                {{ formSearch.departmentName }}
              </el-tag>
              <span class="clear" @click="onClear">{{ $t('com_clear') }}</span>
            </div>
          </div>
        </div>
        <div class="table-bd">
          <custom-table
            tableCode="route_analysis"
            :data="tableList"
            :filterArr="filterArr"
            :index="true"
            @sort="sortChange"
            @column="setColumn"
            @filter="filterChange"
            :slots="['total', 'runRoute', ...timeBucketArr]"
            width="100%"
             height="100%"
          >
            <template v-slot:total="scope">
              <span v-if="statusState === 'count'">{{ scope.row.totalCleanedCount }}</span>
              <span v-else-if="statusState === 'area'">{{ scope.row.totalCleanedArea > 0 ? $numCommaSplit($formatLenLocal(scope.row.totalCleanedArea)) : scope.row.totalCleanedArea }}</span>
              <span v-else-if="statusState === 'time'">{{ $formatSecToHm(scope.row.totalUsageTime, false) }}</span>
              <span v-else></span>
            </template>
            <template v-slot:runRoute="scope">
              <img :src="scope.row.runRoute" class="route-img" @click="onPreview(scope)" />
            </template>
            <!--
              total
                statusState==='count' statusState==='area statusState==='time'
                totalAssistCount  totalCleanedArea  totalUsageTime
              00:00 - 03:59    timeBucket1    timeBucket2 timeBucket3 timeBucket4 timeBucket5 timeBucket6
              时间算法
              0 1 2 3 4 5
              4 5 0 1 2 3
              5-2+1
              5-2+2
              5-2+3-6
              5-2+4-6
            -->
            <template v-for="(column, cindex) in timeBucketArr" :slot="column" slot-scope="scope">
              <template v-for="item in scope.row.timeBucketTotal">
                <!-- {{ +item.timeBucket }}---{{5+utcOffsetNum+cindex+1>5?5+utcOffsetNum+cindex+1-6:5+utcOffsetNum+cindex+1 }} -->
                <template v-if="+item.timeBucket === (5 + utcOffsetNum + cindex + 1 > 5 ? 5 + utcOffsetNum + cindex + 1 - 6 : 5 + utcOffsetNum + cindex + 1)">
                  <span v-if="statusState === 'count'" :key="item">{{ item.cleanedCount }}</span>
                  <span v-else-if="statusState === 'area'" :key="item">{{ item.cleanedArea > 0 ? $numCommaSplit($formatLenLocal(item.cleanedArea)) : item.cleanedArea }}</span>
                  <span v-else-if="statusState === 'time'" :key="item">{{ $formatSecToHm(item.usageTime, false) }}</span>
                  <span v-else :key="item"></span>
                </template>
              </template>
            </template>
          </custom-table>
        </div>
        <div class="table-footer">
          <custom-pagination :total="totalRows" :page="formSearch.page" :size="formSearch.pageSize" @change="onPageChange"></custom-pagination>
        </div>
      </div>
    </div>
    <img-detail-dialog v-if="showImgPreview" @close="showImgPreview = false" :imgData="imgPreviewData"></img-detail-dialog>
  </div>
</template>

<script>
import apis from '@/utils/apis';
import imgDetailDialog from '@/components/imgDetailDialog';

// routeanalysis_gsmc: 公司名称// routeanalysis_xmqymc: 项目/区域名称// routeanalysis_qi_dian_ma: 起点码// routeanalysis_di_tu_ming_cheng: 地图名称// routeanalysis_suo_shu_bu_men: 所属部门// routeanalysis_shai_xuan_xiang: 筛选项// routeanalysis_qing_jie_ci_shu: 清洁次数// routeanalysis_qing_jie_mian_ji: 清洁面积// routeanalysis_qjsc: 清洁时长（min）// routeanalysis_kai_shi_ri: 开始日// routeanalysis_jie_shu_ri: 结束日

export default {
  name: 'routeanalysis',
  computed: {
    // +8 应该是-2 往前推两个时区
    utcOffsetNum() {
      return -this.utcOffset / 4;
    },
    timeBucketArr() {
      return ['timeBucket1', 'timeBucket2', 'timeBucket3', 'timeBucket4', 'timeBucket5', 'timeBucket6'];
    },
    filterArr() {
      const arr = [];
      if (!this.isCoJv) {
        arr.push('orgName');
      }
      return arr;
    }
  },
  components: { imgDetailDialog },
  data() {
    return {
      statusState: '',
      formSearch: {
        page: 1,
        pageSize: 50,
        customerId: '',
        orgName: '',
        bodyNum: '',
        startTime: '',
        endTime: '',
        keyword: '',
        hlcCode: '',
        mapName: '',
        timeRange: '',
        showSubsidiary: '',
        departmentId: '',
        departmentName: ''
      },
      totalRows: null,
      tableList: [],
      // 日
      initValue: '',
      dateTimes: '',
      // 时区
      utcOffset: '',
      imgPreviewData: [],
      showImgPreview: false,
      isFilter: false,
    };
  },
  mounted: function () {
    this.mergeLanguage(null, 'portal_routeanalysis');
    this.initValue = [this.$moment(this.$getLocalTime()).subtract(7, 'day').format('YYYY-MM-DD 00:00:00'), this.$moment(this.$getLocalTime()).subtract(1, 'day').format('YYYY-MM-DD 23:59:59')];
    this.utcOffset = this.$getTimeZoneOffsetNum(); // 时区
  },
  methods: {
    i18nCallback() {
      this.getFuncView(null, () => {
        if (this.funcView.routeanalysis_count_list) {
          this.statusState = 'count';
        } else if (this.funcView.routeanalysis_area_list) {
          this.statusState = 'area';
        } else if (this.funcView.routeanalysis_time_list) {
          this.statusState = 'time';
        }
      });
    },
    departmentTreeFilter(obj) {
      const ret = [obj];
      const ret2 = this.removeEmptyChildren(ret);
      return ret2;
    },
    removeEmptyChildren(nodes) {
      return nodes.map((item) => {
        // 如果 children 存在且是空数组，则删除 children 属性
        if (Array.isArray(item.children) && item.children.length === 0) {
          const newItem = { ...item }; // 创建一个新的对象，避免直接修改原数据
          delete newItem.children; // 删除 children 属性
          return newItem; // 返回没有 children 属性的对象
        }

        // 如果有子节点，递归调用 removeEmptyChildren
        if (item.children && item.children.length > 0) {
          return { ...item, children: this.removeEmptyChildren(item.children) };
        }

        return item; // 其他情况直接返回
      });
    },
    onDepartmentList(list) {
      this.departmentList = list;
    },
    onDepartmentLabel(Label) {
      this.formSearch.departmentName = Label;
    },
    getTableList: function () {
      this.formSearch.showSubsidiary = this.showSubsidiary;
      this.$getJSON(apis.portalSlotworkTotalPage, { ...this.formSearch, departmentId: this.formSearch.departmentId ? this.formSearch.departmentId[this.formSearch.departmentId.length - 1] : '' }).then((res) => {
        const list = res.data.list || [];
        // const list = res.data.list.map(obj => ({
        //   ...obj,
        //   mapId: '484005716762527601'
        // }));
        if (list.length > 0) {
          this.formatAttachList(list, 'mapId', 'i', 'runRoute')
            .then((result) => {
              this.tableList = result;
            })
            .catch(() => {
              this.tableList = list;
            });
        } else {
          this.tableList = list;
        }
        this.totalRows = res.data.total;
      });
    },
    // 清空标签
    onClear() {
      this.formSearch.customerId = '';
      this.formSearch.orgName = '';
      this.formSearch.customerName = '';
      this.formSearch.keyword = '';
      this.formSearch.departmentId = '';
      this.formSearch.departmentName = '';
      this.onPageChange({ page: 1 });
    },
    // 导出数据
    exportRecord: function () {
      this.formSearch.showSubsidiary = this.showSubsidiary;
      this.$exportFlie(apis.portalSiteMonthExport, { ...this.formSearch, departmentId: this.formSearch.departmentId ? this.formSearch.departmentId[this.formSearch.departmentId.length - 1] : '' }).then(() => {});
    },
    // 分页变更
    onPageChange: function ({ page, size }) {
      this.formSearch.page = page;
      this.formSearch.pageSize = size || this.formSearch.pageSize;
      this.getTableList();
    },
    // 查看地图
    onPreview(scope) {
      this.imgPreviewData = [{ attachPath: scope.row.runRoute }];
      this.showImgPreview = true;
    },
  },
};
</script>

<style lang="scss">
@import '@/style/colors.scss';

.routeanalysis-bd {
  padding: 24px;
  .tab-box {
    .form-screen {
      overflow: hidden;
      height: 40px;
      line-height: 40px;
    }
    .icon-filter {
      display: inline-block;
      text-align: center;
      box-sizing: border-box;
      font-size: 14px;
      width: 40px;
      height: 40px;
      color: $--color-text-primary;
      box-shadow: 0 0 0 1.5px #202945 inset;
      border-radius: 50px;
      cursor: pointer;
    }
  }
  .box {
    & > .ub-f1 {
      height: 92px;
      border-radius: 16px;
      background-color: #ffffff;
      padding: 0 24px;
      margin-right: 24px;
      cursor: pointer;
      &:last-child {
        margin-right: 0;
      }
      .box-l {
        h1 {
          font-weight: bold;
          line-height: 17px;
          color: $--color-text-secondary;
          font-size: 12px;
        }
        p {
          margin-top: 4px;
          line-height: 30px;
          font-size: 22px;
          font-weight: bold;
        }
      }
      .box-r {
        height: 44px;
        width: 44px;
        line-height: 44px;
        border-radius: 44px;
        text-align: center;
        background-color: $--color-primary;
        .icon {
          font-size: 20px;
          color: #ffffff;
        }
      }
    }
  }
  .clean-info {
    height: 290px;
    margin-top: 24px;
    margin-bottom: 24px;
    .info {
      padding: 16px;
      border-radius: 16px;
      background-color: #ffffff;
      .ub-f1:first-child {
        padding: 16px;
      }
      h1 {
        font-weight: bold;
        font-size: 18px;
        line-height: 25px;
        color: $--color-text-primary;
      }
      h2 {
        margin-top: 20px;
        line-height: 45px;
        font-size: 32px;
        font-weight: bold;
        color: $--color-primary;
      }
      p {
        margin-top: 20px;
        font-weight: bold;
        line-height: 24px;
        color: $--color-text-secondary;
        span {
          color: $--color-primary;
        }
      }
      .btn {
        margin-top: 48px;
        display: inline-block;
        padding: 0 24px;
        height: 44px;
        border-radius: 30px;
        line-height: 44px;
        font-weight: bold;
        color: $--color-text-primary;
        background-color: $--color-warning;
        cursor: pointer;
        span {
          margin-right: 8px;
        }
        i.icon {
          font-size: 14px;
        }
      }
    }
    .banner {
      margin-left: 24px;
      width: 650px;
      border-radius: 16px;
      background-color: #ffffff;
      padding: 16px;
      border-radius: 16px;
      position: relative;
      img {
        display: block;
        width: 100%;
        border-radius: 12px;
      }
      &::before {
        content: '';
        position: absolute;
        left: 16px;
        right: 16px;
        top: 16px;
        bottom: 16px;
        border-radius: 12px;
        background: linear-gradient(360deg, rgba(32, 41, 69, 0.16) 0%, rgba(32, 41, 69, 0.88) 100%);
      }
    }
  }

  .select-date {
    h1 {
      font-size: 12px;
      line-height: 17px;
      font-weight: bold;
      color: $--color-primary;
      margin-bottom: 4px;
    }
    .el-input__prefix {
      color: $--color-primary;
      font-size: 18px;
      margin-right: 8px;
    }
    .el-input .el-input__inner {
      cursor: pointer;
      height: 40px;
      line-height: 41px;
      padding-left: 34px;
      font-weight: bold;
      color: $--color-text-primary;
    }
    .el-input__suffix {
      margin-right: 30px;
      .el-input__icon:after {
        font-family: 'icon' !important;
        content: '\E7F8';
        font-size: 22px;
        color: $--color-warning;
        margin-bottom: 2px;
      }
    }
  }

  .table-footer {
    margin-top: 16px;
  }

  .table-list {
    background: #ffffff;
    border-radius: 16px;
    padding: 24px 24px 0;
    .header {
      // padding: 24px;
      .label {
        color: #1a1a1a;
        line-height: 40px;
        font-weight: bold;
        float: left;
      }

      .search-content {
        float: right;
      }

      .icon-filter {
        display: inline-block;
        text-align: center;
        box-sizing: border-box;
        font-size: 16px;
        width: 40px;
        height: 40px;
        color: $--color-text-primary;
        box-shadow: 0 0 0 1.5px #202945 inset;
        border-radius: 50px;
        cursor: pointer;
      }
    }

    .title {
      height: 40px;
      font-size: 18px;
      font-weight: bold;
      color: #1a1a1a;
      line-height: 40px;
      display: flex;
      justify-content: space-between;
    }

    .table-bd {
      background: #ffffff;
      border-radius: 16px;
      padding: 24px 24px 0;
      margin-top: 24px;
      height : 550px;
      // 表头
      .route-img {
        cursor: pointer;
        display: block;
        height: 23px;
        width: auto;
        text-align: center;
      }
    }
  }
}
</style>
